export const APPLICATION_FORM_ID = 'applicationForm';
